<div fxLayoutAlign="center center" fxLayout="column" fxFill>
  <h1>OOPS...</h1>
  <p><strong>{{ link }}</strong></p>
  <h2>Link is not active</h2>
</div>
